import { Component } from '@angular/core';
import { Inject} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FiltrosBuscadorPeticion, ListadoPeticionesComponent} from '../listado-peticiones/listado-peticiones.component';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { DatoDetallePeticion } from '../models/DatoDetallePeticion';
import {GestionPeticionService} from "../services/bd/GestionPeticion/gestion-peticion.service";
import {EmailService} from "../services/email.service";

@Component({
  selector: 'ral-buscar-peticion',
  templateUrl: './buscar-peticion.component.html',
  styleUrls: ['./buscar-peticion.component.scss']
})
export class BuscarPeticionComponent extends VentanaFlotante
{
  protected cia : string="";
  protected id:string = "";
  protected estado:number = 3;
  protected fechaInicio:Date = new Date();
  protected fechaFin:Date = new Date();
  protected matricula : string = "";
  protected listadoCias =
  [
    "TUVOZ",
    "CORREDORES",
    "COLABORADORES RLS",
    "REPARABRISAS RLS"
  ];
  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private dialog : MatDialog,
    private gestion: GestionPeticionService,
    private email: EmailService// Additional parameter to override in the constructor
  ) {
    super(dialogRef, data); // Call the parent class constructor
    this.cia=this.listadoCias[0];
    this.estado = 5;
    this.fechaInicio.setDate(this.fechaInicio.getDate()-7);
    const newData = new Date();
    newData.setDate(newData.getDate() + 1);
    this.fechaFin = newData;
  }

  //cierra esta ventana y muestra la ventana del listado de peticiones
  //Junto con la CIA y parámetros que hay que pasar
  cargarDialogPeticiones():void
  {
    if (this.fechaInicio > this.fechaFin) {
      this.data.hojaprin.mostrarArgumentario("Error", ["La fecha de inicio no puede ser más grande de la fecha fin."], false, true, true)
    }
    else if(this.id !== "" && !(/^\d+$/.test(this.id))){
      this.data.hojaprin.mostrarArgumentario("Error", ["El ID debe de ser numérico."], false, true, true)
    }
    else {
      let filtros : FiltrosBuscadorPeticion =
        {
          estado: this.estado,
          cia: this.cia,
          id:Number.parseInt(this.id),
          fInicio: this.fechaInicio,
          fFin: this.fechaFin,
          matricula: this.matricula,
        }
      //Le Pasamos los parametros al dialog de ListadoPeticiones
      this.dialog.open(ListadoPeticionesComponent,
        {
          data:{filtros:filtros, token:this.data.token, hojaprin: this.data.hojaprin}
        }
      ).afterClosed().subscribe((result:any)=>
      {
        if(result != undefined && result != null)
        {
          this.dialogRef.close(result);
        }
      })
    }

  }

  buscarDeshabilitado(): boolean {return !this.fechaInicio || this.estado < 0;}
  actualizarCia(){
    //this.data.hojaprin.mostrarArgumentario("AVISO", ["Debes de abrir el VB Cias Ficheros para actualizar."], false, true, true);
    this.gestion.saveEmailsTuVoz(this.data.token, this.data.hojaprin.usuario).then(res => {
      if(res.length > 0){
        let mensaje = "";
        let bcc = "";
        if (res[0] == 0){
          mensaje = "No hay Emails pendientes para cargar.";
        }else{
          mensaje = "Proceso terminado correctamente. Se han cargado " + res[0] +  " emails de " + (res[0] + res[1]) + " .Emails erroneos: " + res[1];
        }
        var arrParams;
        if (res[1] > 0){
          arrParams = {
            "sender": "callcenter@ralarsa.com",
            "to": ["rluque@ralarsa.com"],
            "bcc": ["desarrollo@ralarsa.com"],
            "subject": "Estado de Carga de Datos de la compañia TUVOZ",
            "body": mensaje
          }
        }else{
          arrParams = {
            "sender": "callcenter@ralarsa.com",
            "to": ["rluque@ralarsa.com"],
            "subject": "Estado de Carga de Datos de la compañia TUVOZ",
            "body": mensaje
          }
        }
        this.email.enviarEmail(this.data.token, arrParams).then(res => {
          if (res == "OK"){
            this.data.hojaprin.mostrarArgumentario("OK", ["Proceso terminado correctamente."], false, true, false);
          }
        })
      }
    });
  }
}
